import React from 'react'
import Select, { components } from 'react-select'
import * as styles from '../../../config/styles'

const StatusOptions = (props) => {
    const options = props.options
    const name = props.name
    const value = props.value
    const onChange = props.onChange
    const className = props.className || ""
    
    const { Option, SingleValue } = components
    const IconOption = props => (
        <Option {...props}>
            {props.data.icon && <i className={`fa ${props.data.icon}`} style={{ marginRight: 5 }} />}
            {props.data.label}
        </Option>
    )
    const IconSingleValue = props => (
        <SingleValue {...props}>
            {props.data.icon && <i className={`fa ${props.data.icon}`} style={{ marginRight: 5 }} />}
            {props.data.label}
        </SingleValue>
    )

    const onValueChange = (obj) => {
        let targetValue = 0

        if (obj) {
            targetValue = obj.value
        }

        let event = {
            target: {
                name,
                value: targetValue
            }
        }
        onChange(event)
    }

    if(!options) {
        return <div />
    }

    return (
        <div className="col-sm-5 m-b-xs" style={{paddingLeft: "0px"}}>
            <Select
                key={name}
                name={name}
                className={className}
                value={options.filter(option => option.value === value)}
                onChange={onValueChange}
                options={options}
                placeholder=""
                isMulti={false}
                styles={styles.singleSelect}
                maxMenuHeight={500}
                components={{ Option: IconOption, SingleValue: IconSingleValue }}
            />
        </div>
    )
}

export default StatusOptions
